module.exports = __webpack_public_path__ + "059bd89569c3213c222fda69b5d5a2b8.jpg";